export enum MessageType {
  Ready = 'ready',
  StartMyBooking = 'start-my-booking',
  Start = 'start',
  Close = 'close',
  ResizeFrame = 'resize',
  SetTheme = 'set-theme',
  OpenInIframe = 'open-in-iframe',
  BookingFormLoaded = 'booking_form_loaded',
  BookingComplete = 'booking_complete',
  BookingCompleteFacebook = 'booking_complete_facebook',
  BookingFailed = 'booking_failed',
  ChooseCity = 'choose_city',
  ChooseTreatment = 'choose_treatment',
  ChooseClinic = 'choose_clinic',
  ChooseAppointment = 'choose_appointment',
  ShowBookingSummary = 'show_booking_summary',
  AddContactInfo = 'add_contact_info',
  ShowBookingConfirmation = 'show_booking_confirmation',
  ReloadWidget = 'reload_widget',
  NotFoundBooking = 'not_found_booking',
  PhoneNumberClicked = 'phone_number_clicked',
  WidgetDisplayed = 'widget_displayed',
  LoadTokenizationScreen = 'load_tokenization_screen',
  TokenizationError = 'tokenization_error',
  TokenizationCancel = 'tokenization_cancel',
  TokenizationComplete = 'tokenization_complete',
  ChooseUpcomingBooking = 'choose_upcoming_booking',
  ChoosePreviousBooking = 'choose-previous-booking',
  ChangeMyBookingClicked = 'change-my-booking-clicked',
  CancelMyBookingClicked = 'cancel-my-booking-clicked',
  OpenPromoSection = 'open-promo-section',
  CheckPromoCode = 'check-promo-code',
  InvalidPromoCode = 'invalid-promo-code',
  ValidPromoCode = 'valid-promo-code',
}

export enum DataLayerEventName {
  Checkout = 'checkout',
  Transaction = 'transaction',
  BookingCompleted = 'booking_completed',
  BookingFailed = 'booking_failed',
  FilterCity = 'filter-city',
  FilterTreatment = 'filter-treatment',
  FilterClinic = 'filter-clinic',
  FilterAppointment = 'filter-appointment',
  BookingSummary = 'booking-summary',
  BookingContactInfo = 'filter-booking-contact-info',
  BookingConfirmation = 'booking-confirmation',
  Reschedule = 'reschedule',
  BlockFingerprint = 'block-fingerprint',
  Growthbook = 'growthbook',
  PhoneNumberClicked = 'phone_number_clicked',
  WidgetDisplayed = 'widget_displayed',
  LoadTokenizationScreen = 'load_tokenization_screen',
  TokenizationError = 'tokenization_error',
  TokenizationCancel = 'tokenization_cancel',
  TokenizationComplete = 'tokenization_complete',
  ChooseUpcomingBooking = 'choose-upcoming-booking',
  ChoosePreviousBooking = 'choose-previous-booking',
  ChangeMyBookingClicked = 'change-my-booking-clicked',
  CancelMyBookingClicked = 'cancel-my-booking-clicked',
  OpenPromoSection = 'open-promo-section',
  CheckPromoCode = 'check-promo-code',
  InvalidPromoCode = 'invalid-promo-code',
  ValidPromoCode = 'valid-promo-code',
}

export enum SVGIconType {
  LocationCross = 'location-cross',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  DoubleChevronLeft = 'double-chevron-left',
  DoctorUser = 'doctor-user',
  EditPen = 'edit-pen',
  Close = 'close',
  Filter = 'filter',
  CheckMark = 'checkmark',
  CalendarEdit = 'calendar-edit',
  Google = 'google-brand',
  Apple = 'apple-brand',
  Outlook = 'outlook-brand',
  Yahoo = 'yahoo-brand',
  MyBookings = 'my-bookings',
  BankID = 'bankid',
  Treatment = 'treatment',
  Clinic = 'clinic',
  Phone = 'phone',
  CloseCircle = 'close-circle',
  Info = 'info',
  InfoSolid = 'info-solid',
  Clock = 'clock',
  ArrowRight = 'arrow-right',
  StarIcon = 'star-icon',
  ProfileIcon = 'profile-icon',
}

export enum OnlineDentistKeys {
  name = 'Online Dentist',
  id = '5253',
}

export enum AquaAkuttidIds {
  Akuttid = '78',
  AkuttidStandBy = '207',
}

export enum WidgetMode {
  Embedded = 'embedded',
  Modal = 'modal',
}

export enum IntegrationType {
  Landing = 'landing',
  PatientHub = 'patient-hub',
}

export enum ConfigFeature {
  PromoSection = 'promo_section',
}
